import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Count-up number that animates once when scrolled into view.
export default function StatCounter({ value, suffix = "", decimals = 0, display = null }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!inView || value == null) return;
    let raf;
    const duration = 1800;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCurrent(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  const shown = display != null ? display : `${current.toFixed(decimals)}${suffix}`;

  return (
    <span ref={ref} data-testid="stat-value">
      {shown}
    </span>
  );
}
